import '../home/home.scss';
import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Translate, translate, Storage } from 'react-jhipster';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Button, Input, Label, Spinner } from 'reactstrap';
import { styled, createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Links from '@mui/material/Link';
import Container from '@mui/material/Container';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Search from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import PropTypes from 'prop-types';
import { visuallyHidden } from '@mui/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Alert } from 'reactstrap';
import moment from 'moment/moment';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Clear } from '@mui/icons-material';
import { getEntitiesWithFalseAmountTransferred } from 'app/entities/booking-confirmation/booking-confirmation.reducer';
import { AUTHORITIES } from 'app/config/constants';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { ar, enUS } from 'date-fns/locale';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import EventIcon from '@mui/icons-material/Event';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import {
  getEntityWithoutPending,
  updateEntity as updateQuotation,
  partialUpdateEntity as partialUpdateQuotation,
} from 'app/entities/quotation/quotation.reducer';
import { uploadAmountTransferredDocument } from 'app/entities/file/file.reducer';
import { AmountTransferDocUploadDialog } from 'app/modules/pending-amount-transfer/components/amount-transfer-doc-upload-dialog';
import { convertFileToBase64 } from 'app/shared/util/file-utils';
import { inputStyle, labelStyle } from 'app/entities/quotation/bought/quotation-bought.style';
import { IQuotation } from 'app/shared/model/quotation.model';
import { sendAmountTransferredEmail } from 'app/entities/notification-record/notification-record.reducer';
import { IBookingConfirmation } from 'app/shared/model/booking-confirmation.model';

window.onload = function () {
  sessionStorage.removeItem('filterSearch');
};
export const PendingAmountTransfer = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const specBranch = useAppSelector(state => state.branch.entity);
  const user = useAppSelector(state => state.userManagement.user);
  const bookingConfirmationList = useAppSelector(state => state.bookingConfirmation.entities);
  const account = useAppSelector(state => state.authentication.account);
  const [pageNo, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [searchOnChange, setSearchOnChange] = React.useState(sessionStorage.getItem('filterSearch') || '');
  const [searchTerm, setSearchTerm] = React.useState(searchOnChange);
  const [isDone, setIsDone] = useState(false);
  const totalCount = useAppSelector(state => state.bookingConfirmation.totalItems);
  const formatTwoDigits = digit => ('0' + digit).slice(-2);
  const tempDate = new Date();
  const currentDate = `${formatTwoDigits(tempDate.getMonth() + 1)}/${formatTwoDigits(tempDate.getDate())}/${tempDate.getFullYear()}`;

  const [isDocDialogOpen, setIsDocDialogOpen] = useState(false);
  const [amountTransferChecked, setAmountTransferChecked] = React.useState({});
  const [amountTransferUploadedDocs, setAmountTransferUploadedDocs] = useState<Record<number, File | null>>({});
  const [amountTransferUploadedDocNames, setAmountTransferUploadedDocNames] = useState<Record<number, string>>({});
  const [currentUploadEntityId, setCurrentUploadEntityId] = useState<number | null>(null);
  const [isSaving, setIsSaving] = useState<Record<number, boolean>>({});

  const shortenFileName = (name: string, maxLength = 50) => {
    if (name.length <= maxLength) return name;
    const ext = name.split('.').pop();
    const base = name.replace(`.${ext}`, '');
    return base.substring(0, maxLength - ext.length - 5) + `...${ext}`;
  };

  const handleChangeCheckbox = id => e => {
    setAmountTransferChecked(prev => ({
      ...prev,
      [id]: e.target.checked,
    }));
  };

  useEffect(() => {
    if (bookingConfirmationList) {
      const initialState = {};
      bookingConfirmationList.forEach(item => {
        initialState[item.id] = item.amountTransferred || false;
      });
      setAmountTransferChecked(initialState);
    }
  }, [bookingConfirmationList]);

  const handleOpenDocUploadDialog = entityId => {
    setCurrentUploadEntityId(entityId);
    setIsDocDialogOpen(true);
  };

  const handleCloseDocUploadDialog = () => {
    setIsDocDialogOpen(false);
    setCurrentUploadEntityId(null);
  };

  const handleChangeUploadedFile = (type, id, docsValue) => {
    if (type === 'delete') {
      setAmountTransferUploadedDocs(prev => {
        const newDocs = { ...prev };
        delete newDocs[id];
        return newDocs;
      });
      setAmountTransferUploadedDocNames(prev => {
        const newNames = { ...prev };
        delete newNames[id];
        return newNames;
      });
    }

    if (type === 'upload') {
      setAmountTransferUploadedDocs(prev => ({ ...prev, [id]: docsValue.file }));
      setAmountTransferUploadedDocNames(prev => ({ ...prev, [id]: docsValue.name }));
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy]?.toString()?.toLowerCase() < a[orderBy]?.toString()?.toLowerCase()) {
      return -1;
    }
    if (b[orderBy]?.toString()?.toLowerCase() > a[orderBy]?.toString()?.toLowerCase()) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  }

  const rows = bookingConfirmationList?.map((obj, i) => ({
    ...obj,
    id: obj?.quotationId,
    customerName: obj?.customerName,
    poNumber: obj?.transactionRefNo === null ? '-' : obj?.transactionRefNo,
    bankName: obj?.bankName,
    amount: obj?.amount.toLocaleString() + ' ' + obj?.buyCurrency,
    lpoReference: obj?.lpoReference,
    contractReference: obj?.contractReference,
    bookingConfirmationDate: moment(obj?.createdDate).format('YYYY/MM/DD'),
  }));

  const headCells = [
    {
      id: 'id',
      numeric: true,
      disablePadding: false,
      label: `${translate('home.table.orderNo')}`,
      disableSorting: false,
    },
    {
      id: 'poNumber',
      numeric: true,
      disablePadding: false,
      label: `${translate('home.table.poNo')}`,
      disableSorting: false,
    },
    {
      id: 'customerName',
      numeric: false,
      disablePadding: false,
      label: `${translate('home.table.customerName')}`,
      disableSorting: false,
    },
    {
      id: 'bankName',
      numeric: false,
      disablePadding: false,
      label: `${translate('home.table.bank')}`,
      disableSorting: false,
    },
    {
      id: 'amount',
      numeric: true,
      disablePadding: false,
      label: `${translate('home.table.value')}`,
      disableSorting: false,
    },
    {
      id: 'lpoReference',
      numeric: false,
      disablePadding: false,
      label: `${translate('home.table.lpoReference')}`,
      disableSorting: false,
    },
    {
      id: 'contractReference',
      numeric: false,
      disablePadding: false,
      label: `${translate('home.table.contractReference')}`,
      disableSorting: false,
    },
    {
      id: 'bookingConfirmationDate',
      numeric: false,
      disablePadding: false,
      label: `${translate('home.table.bookingConfirmationDate')}`,
      disableSorting: true,
    },
    {
      id: 'amountTransferred',
      numeric: false,
      disablePadding: false,
      label: `${translate('home.table.amountTransferred')}`,
      disableSorting: false,
    },
    {
      id: 'transferSlip',
      numeric: false,
      disablePadding: false,
      label: `${translate('home.table.transferSlip')}`,
      disableSorting: true,
    },
    {
      id: 'action',
      numeric: false,
      disablePadding: false,
      label: ' ',
      disableSorting: true,
    },
  ];

  function EnhancedTableHead(tableHead) {
    const { order, orderBy, onRequestSort } = tableHead;
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow className={'enhanced-table-cancel'}>
          {headCells?.map(headCell => (
            <StyledTableCell
              key={headCell?.id}
              align="left"
              padding={headCell?.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell?.id ? order : false}
            >
              {headCell?.disableSorting ? (
                headCell.label
              ) : (
                <StyledTableSortLabel
                  active={orderBy === headCell?.id}
                  direction={orderBy === headCell?.id ? order : 'asc'}
                  onClick={createSortHandler(headCell?.id)}
                >
                  {headCell?.label}
                  {orderBy === headCell?.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </StyledTableSortLabel>
              )}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSave = async (entity: any) => {
    try {
      setIsSaving(prev => ({ ...prev, [entity.id]: true }));
      const file = amountTransferUploadedDocs[entity.id];

      // ---- 1) Update quotation table amountTransferred column ----
      const response = await dispatch(getEntityWithoutPending(entity.id)).unwrap();
      const completeQuotation: IQuotation = response.data;
      const updatedQuotationEntity: IQuotation = {
        ...completeQuotation,
        amountTransferred: amountTransferChecked[entity.id],
      };
      await dispatch(updateQuotation(updatedQuotationEntity)).unwrap();

      // ---- 2) Upload document for amount transfer ----
      const base64File = await convertFileToBase64(file);
      const quotationDocumentsDTO = {
        transactionRefNo: entity.transactionRefNo,
        files: [
          {
            fileName: file.name,
            fileType: file.type,
            file: base64File,
            order: 0,
          },
        ],
      };
      await dispatch(
        uploadAmountTransferredDocument({
          id: entity.id,
          documents: quotationDocumentsDTO,
        })
      ).unwrap();

      // ---- 3) Send email with file attachment ----
      const bookingConfirmationEntity: IBookingConfirmation = {
        quotationId: entity.id,
        lpoReference: entity.lpoReference,
        contractReference: entity.contractReference,
      };
      dispatch(sendAmountTransferredEmail(bookingConfirmationEntity));

      // Refresh the list to remove this entity
      dispatch(
        getEntitiesWithFalseAmountTransferred({
          page: pageNo,
          size: rowsPerPage,
          sort: `id,asc`,
        })
      );

      toast.success('Saved successfully and email sent!');
    } catch (error) {
      console.error('Error saving:', error);
      toast.error('Failed to save.');
    } finally {
      setIsSaving(prev => ({ ...prev, [entity.id]: false }));
    }
  };

  // to change colour of the table
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'rgba(255,255,255,0)',
      color: theme.palette.common.white,
      fontWeight: 'bold',
      letterSpacing: 1,
      textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const StyledTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
    '&.MuiTableSortLabel-root': {
      color: 'white',
    },
    '&.MuiTableSortLabel-root:hover': {
      color: 'white',
    },
    '&.Mui-active': {
      color: 'white',
    },
    '& .MuiTableSortLabel-icon': {
      color: 'white !important',
    },
  }));

  let responsiveFont = createTheme();
  responsiveFont = responsiveFontSizes(responsiveFont);

  useEffect(() => {
    dispatch(
      getEntitiesWithFalseAmountTransferred({
        page: 0,
        size: 0,
        sort: `id,asc`,
      })
    );
  }, []);

  return (
    <Container>
      {account?.login ? (
        <div>
          <AmountTransferDocUploadDialog
            openDocUploadDialog={isDocDialogOpen}
            handleCloseDocUploadDialog={handleCloseDocUploadDialog}
            onFileSelected={(file, filename) => handleChangeUploadedFile('upload', currentUploadEntityId, { file, name: filename })}
            inputStyle={inputStyle}
            labelStyle={labelStyle}
            initialFileName={amountTransferUploadedDocNames[currentUploadEntityId] || ''}
          />

          <Grid container spacing={2} sx={{ mt: 1, alignItems: 'center' }}>
            <Grid item xs={12} sm={6} md={6} className="left-side-component-flex">
              <ThemeProvider theme={responsiveFont}>
                <Typography variant="h4" component="div">
                  {translate('home.topInfo.pendingAmountTransferred.title')}
                </Typography>
              </ThemeProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="right-side-component-flex">
              <Links onClick={() => props.history.push('/home')} underline="hover">
                <Translate contentKey="home.returnHomeLink" />
              </Links>
            </Grid>
          </Grid>

          <Paper className={'paper-table'} sx={{ width: '100%', overflow: 'hidden', mb: 8, mt: 8 }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table sx={{ minWidth: 650 }} aria-label="sticky table">
                <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
                <TableBody>
                  {bookingConfirmationList &&
                    stableSort(rows, getComparator(order, orderBy))
                      .slice(pageNo * rowsPerPage, pageNo * rowsPerPage + rowsPerPage)
                      .map(entity => (
                        <StyledTableRow key={entity?.id}>
                          <StyledTableCell component="th" scope="row">
                            {entity?.id}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {entity?.poNumber}
                          </StyledTableCell>
                          <StyledTableCell>{entity?.customerName}</StyledTableCell>
                          <StyledTableCell>{entity?.bankName}</StyledTableCell>
                          <StyledTableCell>{entity?.amount}</StyledTableCell>
                          <StyledTableCell>{entity?.lpoReference}</StyledTableCell>
                          <StyledTableCell>{entity?.contractReference}</StyledTableCell>
                          <StyledTableCell>{entity?.bookingConfirmationDate}</StyledTableCell>
                          <StyledTableCell>
                            <Checkbox
                              checked={!!amountTransferChecked[entity?.id]}
                              onChange={handleChangeCheckbox(entity?.id)}
                              size={'small'}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            {!amountTransferUploadedDocNames[entity?.id] ? (
                              <Button className={'btn-detail'} color="primary" outline onClick={() => handleOpenDocUploadDialog(entity.id)}>
                                <Translate contentKey="home.table.upload">Upload</Translate>
                              </Button>
                            ) : (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span>{amountTransferUploadedDocNames[entity?.id]}</span>

                                <IconButton size="small" onClick={() => handleOpenDocUploadDialog(entity.id)}>
                                  <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton size="small" color="error" onClick={() => handleChangeUploadedFile('delete', entity.id, null)}>
                                  <DeleteOutlineIcon fontSize="small" />
                                </IconButton>
                              </div>
                            )}
                          </StyledTableCell>
                          <StyledTableCell>
                            <Button
                              className={'btn-detail'}
                              color="primary"
                              onClick={() => {
                                handleSave(entity);
                              }}
                              disabled={
                                !amountTransferChecked[entity?.id] || !amountTransferUploadedDocs[entity?.id] || isSaving[entity?.id]
                              }
                            >
                              {isSaving[entity?.id] ? (
                                <>
                                  <Spinner size="sm" className="me-1" />
                                  <Translate contentKey="entity.action.saving">Saving...</Translate>
                                </>
                              ) : (
                                <Translate contentKey="entity.action.save">Save</Translate>
                              )}
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              className={Storage.session.get('locale') === 'en' ? 'table-pagination' : 'table-pagination-arabic'}
              sx={{ display: 'block' }}
              rowsPerPageOptions={[5, 25, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={pageNo}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={translate('home.table.rowsPerPage')}
            />
          </Paper>
        </div>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default PendingAmountTransfer;
